import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import messages from './messages';

const AddDeviceToGroup = ({ onClick }) => (
  <RowMenuItem
    dataTestId="access-settings-add-device"
    icon={<AddIcon />}
    label={<FormattedMessage {...messages.AccessSettingsDataGridTableRowActionsAddDevice} />}
    onClick={onClick}
  />
);

AddDeviceToGroup.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AddDeviceToGroup;
